/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import { _object } from 'utils/interfaces'

import { Button, InputField } from '../form-inputs'

import { testimonialService } from 'services/testmonial.service'

const TestimonialEditModal = (props: _object) => {
  // })

  const [loading, setLoading] = useState(false)
  const [testmonial, setTestimonial] = useState<_object>({})

  useEffect(() => {
    testimonialService.getTestimonialDetails(props?.id).then((results: _object) => {
      setTestimonial(results)
    })
  }, [props?.id])

  const validationSchema = Yup.object({
    name: Yup.string().label('Name').required(),
    designation: Yup.string().label('Designation').required()
  })
  const formik: _object = useFormik({
    initialValues: {
      name: testmonial?.name || '',
      designation: testmonial?.designation || '',
      description: testmonial?.description || ''
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setLoading(true)
      testimonialService.updateTestimonial(props.id, values).then((results: _object) => {
        if (results.error == false) {
          window.location.reload()
        }
        setLoading(false)
      })
    }
  })

  return (
    <div
      id={`testimonial-modal${props?.id}`}
      tabIndex={-1}
      aria-hidden="true"
      className="fixed top-0 right-0 left-0 z-50 flex hidden h-[calc(100%-1rem)] max-h-full w-full items-center justify-center overflow-x-hidden overflow-y-auto md:inset-0"
    >
      <div className="fixed inset-0 bg-black/50"></div>

      {/* Modal Content */}
      <div className="relative z-10 max-h-full w-full max-w-2xl rounded-lg border border-gray-200 bg-white shadow-sm">
        <div className="flex items-center justify-between rounded-t border-b border-gray-200 p-4">
          <h3 className="text-lg font-semibold">Edit Testimonial</h3>
          <button
            type="button"
            className="ms-auto inline-flex h-8 w-8 items-center justify-center rounded-lg bg-transparent text-sm text-gray-400"
            data-modal-hide={`testimonial-modal${props?.id}`}
          >
            <svg
              className="h-3 w-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
        </div>{' '}
        <div className="grid grid-cols-1 p-4">
          <div className="flex flex-col gap-4">
            <form onSubmit={formik.handleSubmit}>
              <div className="mb-4">
                <InputField
                  label="Name"
                  name="name"
                  type="text"
                  placeholder="Testimonial Name"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  onBlur={formik.handleBlur}
                  error={formik.touched.name && formik.errors.name}
                  required
                />
              </div>
              <div className="mb-4">
                <InputField
                  label="Designation"
                  name="designation"
                  type="text"
                  placeholder="Designation"
                  onChange={formik.handleChange}
                  value={formik.values.designation}
                  onBlur={formik.handleBlur}
                  error={formik.touched.designation && formik.errors.designation}
                  required
                />
              </div>

              <div className="mb-4">
                <label className="block mb-1 font-medium">Description</label>
                <textarea
                  id="description"
                  name="description"
                  placeholder="Description"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.description}
                  className="w-full border border-gray-300 rounded-md p-2 h-32 focus:border-gray-400 focus:outline-none"
                  required
                ></textarea>

                {formik.touched.description && formik.errors.description && (
                  <p className="text-red-500 text-sm mt-1">{formik.errors.description}</p>
                )}
              </div>

              <Button
                label=" Save Changes"
                type="submit"
                className="rounded-lg bg-purple-900 py-2 text-center text-sm text-white transition hover:bg-purple-950"
                loading={loading}
                disabled={!formik.isValid || !formik.dirty}
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TestimonialEditModal
